export default {
  invoices: state => state.invoices,
  invoice: state => state.invoice,

  loading: state => state.loading,
  error: state => state.error,

  filters: state => state.filters,
  pagination: state => state.pagination,

  isEmpty: state => state.users.length === 0
}